import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { Form, InputNumber, Divider, Select, Button, Switch } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
const Option = Select.Option;

const FormReservationsConfigResto = ({ onSubmit, restaurant, isSaving, listAverageReservationTime, listPreviousCancellationTime, onExit }) => {

    const [form] = Form.useForm();

    const getAverageReservationTime = () => {
        var averageReservationTime = [];
        if(restaurant.averageReservationTime) {
            for(var key in listAverageReservationTime) {
                if(listAverageReservationTime[key]) {
                    if(key === restaurant.averageReservationTime.toString()) {
                        averageReservationTime.push(key);
                        break;
                    }
                }
            }
        }
        return averageReservationTime;
    }

    const getReservePreviousCancellationTime = () => {
        var reservePreviousCancellationTime = [];
        if(restaurant.reservePreviousCancellationTime) {
            for(var key in listPreviousCancellationTime) {
                if(listPreviousCancellationTime[key]) {
                    if(key === restaurant.reservePreviousCancellationTime.toString()) {
                        reservePreviousCancellationTime.push(key);
                        break;
                    }
                }
            }
        }
        return reservePreviousCancellationTime;
    }

    return (
            <Grid>
                <Form onFinish={onSubmit} form={form} initialValues={{
                    field_total_capacity: restaurant.totalCapacity !== undefined ? restaurant.totalCapacity : 1,
                    field_reservation_capacity: restaurant.reservationCapacity !== undefined ? restaurant.reservationCapacity : 1,
                    field_automatic_reservations: restaurant.automaticReservations,
                    field_min_places_per_reservation: restaurant.minPlacesPerReservation !== undefined ? restaurant.minPlacesPerReservation : 1,
                    field_max_places_per_reservation: restaurant.maxPlacesPerReservation !== undefined ? restaurant.maxPlacesPerReservation : 1,
                    field_average_reservation_time: getAverageReservationTime(),
                    field_minimum_previous_reservation_hours: restaurant.minimumPreviousReservationHours !== undefined ? restaurant.minimumPreviousReservationHours : 1,
                    field_maximum_previous_reservation_days: restaurant.maximumPreviousReservationDays !== undefined ? restaurant.maximumPreviousReservationDays : 1,
                    field_reserve_previous_cancellation_time: getReservePreviousCancellationTime(),
                }}>
                    <Row>
                        <Col xs={12} sm={4}>
                            <Form.Item label="Capacidad total" name="field_total_capacity" rules={[{ required: true, message: 'Por favor, complete la capacidad total del restaurante', }]}>
                                <InputNumber min={0}/>
                            </Form.Item>
                        </Col>
                        <Col xs={12} sm={4}>
                            <Form.Item label="Capacidad para reservas" name="field_reservation_capacity" rules={[{ required: true, message: 'Por favor, complete la capacidad disponible para reservas del restaurante', }]}>
                                <InputNumber min={0}/>
                            </Form.Item>
                        </Col>
                        <Col xs={12} sm={4}>
                            <Form.Item label="Aceptación de reservas automático" name="field_automatic_reservations">
                                <Switch
                                defaultChecked={restaurant.automaticReservations}
                                checkedChildren={<CheckOutlined />}
                                unCheckedChildren={<CloseOutlined />}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Divider></Divider>
                    <Row>
                        <Col xs={12} sm={6}>
                            <Form.Item label="Cantidad mínima de personas por reserva" name="field_min_places_per_reservation" rules={[{ required: true, message: 'Por favor, complete la cantidad mínima de personas por reserva del restaurante', }]}>
                                <InputNumber min={1}/>
                            </Form.Item>
                        </Col>
                        <Col xs={12} sm={6}>
                            <Form.Item label="Cantidad máxima de personas por reserva" name="field_max_places_per_reservation" rules={[{ required: true, message: 'Por favor, complete la cantidad máxima de personas por reserva del restaurante', }]}>
                                <InputNumber min={1}/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Divider></Divider>
                    <Row>
                        <Col xs={12} sm={12}>
                            <Form.Item label="Promedio de permanencia por reserva" name="field_average_reservation_time" rules={[{ required: true, message: 'Por favor, seleccione el promedio de permanencia por reserva del restaurante' },]}>
                                <Select
                                    placeholder="Promedio de permanencia">
                                    {
                                        listAverageReservationTime && Object.keys(listAverageReservationTime).map(key => <Option key={key} value={key}>{listAverageReservationTime[key]}</Option>)
                                    }
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Divider></Divider>
                    <Row>
                        <Col xs={12} sm={6}>
                            <Form.Item label="Tiempo mínimo de anticipo de reserva (horas)" name="field_minimum_previous_reservation_hours" rules={[{ required: true, message: 'Por favor, complete el tiempo mínimo de anticipo de reserva del restaurante', }]}>
                                <InputNumber min={0} max={72}/>
                            </Form.Item>
                        </Col>
                        <Col xs={12} sm={6}>
                            <Form.Item label="Días previos de reserva" name="field_maximum_previous_reservation_days" rules={[{ required: true, message: 'Por favor, complete el tiempo máximo previo de reserva del restaurante', }]}>
                                <InputNumber min={1} max={14}/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Divider></Divider>
                    <Row>
                        <Col xs={12} sm={12}>
                            <Form.Item label="Tiempo previo límite para cancelar una reserva" name="field_reserve_previous_cancellation_time" rules={[{ required: true, message: 'Por favor, seleccione el tiempo previo límite para cancelar una reserva del restaurante' },]}>
                                <Select
                                    placeholder="tiempo límite">
                                    {
                                        listPreviousCancellationTime && Object.keys(listPreviousCancellationTime).map(key => <Option key={key} value={key}>{listPreviousCancellationTime[key]}</Option>)
                                    }
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Divider></Divider>
                    <Row>
                    <Col xs={12} sm={5} md={4}>
                        <Row center="xs" start="sm">
                            <Col xs={12} sm={12}>
                                <Form.Item>
                                    {
                                        isSaving ?
                                            <Button type="primary" htmlType="submit" disabled={true} loading>
                                                Guardando
                                            </Button>
                                            :
                                            <Button type="primary" htmlType="submit">
                                                Guardar
                                            </Button>
                                    }
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} sm={2} md={4}></Col>
                    <Col xs={12} sm={5} md={4}>
                        <Row center="xs" end="sm">
                            <Col xs={12} sm={12}>
                                <Form.Item>
                                    {
                                        <Button disabled={isSaving} onClick={onExit}>
                                            Cancelar
                                        </Button>
                                    }
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                </Form>
            </Grid>
    );
};

FormReservationsConfigResto.propTypes = {
    restaurant: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    isSaving: PropTypes.bool.isRequired,
};

export default FormReservationsConfigResto;